import { render, staticRenderFns } from "./BoostTransactionList.vue?vue&type=template&id=087613f8"
import script from "./BoostTransactionList.vue?vue&type=script&lang=js"
export * from "./BoostTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports